<template>
  <div>
    <!-- 收货地址 -->
    <table class="table table-hover w-100">
      <tr>
        <th width="">地址</th>
        <th width="">收货人</th>
        <th width="">联系电话</th>
        <!-- <th width="">邮政编码</th> -->
        <th width="300">操作</th>
      </tr>
      <template v-for="(item, index) in listData" v-if="listData.length > 0">
        <tr :key="index">
          <td>
            <div class="sp-addr">
              <span>{{ item.detailAddress }}</span
              ><i v-if="item.defaultTag == 1">默认</i>
            </div>
          </td>
          <td>{{ item.receiverName }}</td>
          <td>{{ item.receiverPhone }}</td>
          <!-- <td>暂无</td> -->
          <td>
            <a class="btns orange" @click="delAddress(item.uid, index)">删除</a>
            <a class="btns blue" @click="showUpdateAddress(item, index)"
              >修改</a
            >
            <a
              class="btns"
              :class="{ cyan: item.defaultTag != 1 }"
              @click="item.defaultTag != 1 ? setNormalAddress(item.uid) : ''"
              >设为默认</a
            >
            <a
              class="btns blue"
              @click="item.defaultTag != 1 ? setNormalAddress(item.uid) : ''"
              v-if="choose && item.defaultTag != 1"
              >选择地址</a
            >
          </td>
        </tr>
      </template>
      <tr v-if="listData.length <= 0">
        <td colspan="5">暂无数据</td>
      </tr>
    </table>
    <div class="user-address1 w-100"><a @click="addAddress">新增地址</a></div>
    <div class="eject-box" id="addrBox">
      <div class="center-center">
        <div class="eject-bg" onclick="$('.eject-box').fadeOut();"></div>
        <form action="" class="user-address2" method="post">
          <i class="closes" onclick="$('.eject-box').fadeOut();"></i>
          <div class="box0 w-100">新增收货地址</div>
          <div class="between-center w-100">
            <div class="box1">
              <i>*</i
              ><input
                type="text"
                class="text"
                v-model="name"
                placeholder="请输入收货人姓名"
              />
            </div>
            <div class="box1">
              <i>*</i
              ><input
                type="number"
                class="text"
                oninput="if(value.length>11)value=value.slice(0,11)"
                v-model="phone"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="box1">
              <el-cascader
                size="large"
                :options="cities"
                :props="optionProps"
                v-model="addtions.selectedOptions"
                placeholder="请选择所在区域"
                @change="handleChange"
              >
              </el-cascader>
            </div>
          </div>
          <div class="box1 w-100">
            <i>*</i
            ><input
              type="text"
              class="text"
              v-model="info"
              placeholder="请输入详细地址"
            />
          </div>
          <div class="box3 w-100">
            <input
              type="button"
              value="确定"
              @click="updateAddress"
              :disabled="isDisable"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSeeAddress,
  getAddAddress,
} from '@/common/http.js';
import {
  message
} from '@/common/common.js'
const areaData = require('../../../static/area.json')
export default {
  data () {
    return {
      listData: [],
      name: '',
      phone: '',
      phoneVerification: /^[1-9]\d{10}$/,
      isDisable: false,
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      addtions: {
        selectedOptions: [],
        names: ''
      },
      update: false,
      info: '',
      addressId: '',
      cities: [],// 城市列表
      choose: false,
      addressInfo: {}
    }
  },
  mounted () {
    if (this.$route.query.choose) {
      this.choose = this.$route.query.choose
    }
    this.$emit('change_bread', 9);
    this.getSee();
  },
  created () {
    this.cities = areaData.data[0].children;
  },
  methods: {
    // 获取地址
    async getSee () {
      let {
        data
      } = await getSeeAddress({
        pageIndex: 1,
        pageSize: 999999
      })
      this.listData = data.rows;
    },
    handleChange (value) {
      // 我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      this.addtions.selectedOptions = value;
      let name = '';
      this.addtions.selectedOptions.map(item => name += this.getAreaName(this.cities, item) + ',')
      this.addtions.names = name;
    },
    getAreaName (cities, id) {
      let str = ''
      const getStr = function (list) {
        list.forEach(function (row) {
          if (row.id === id) {
            str += row.name
          }
          if (row.children) {
            getStr(row.children)
          }
        })
      }
      getStr(cities)
      return str
    },
    addAddress () {
      this.update = false;
      if (this.update == false) {
        this.name = '';
        this.phone = '';
        this.info = '';
      }
      $('#addrBox').fadeIn();
    },
    // 新增/修改地址
    updateAddress () {
      this.isDisable = true;

      setTimeout(() => {
        this.isDisable = false
      }, 1000)
      if (!(this.phoneVerification.test(this.phone))) {
        message({
          message: '请输入正确的手机号码',
          type: 'warning'
        })
        return
      }
      if (this.name == '' || this.phone == '' || this.showAddr == '' || this.info == '') {
        message({
          message: '输入内容不能为空!',
          type: 'warning'
        })
        return
      }
      // 修改
      const province = this.addtions.selectedOptions[0];
      const city = this.addtions.selectedOptions[1];
      const county = this.addtions.selectedOptions[2];
      const area = this.addtions.names.replace(/,/g, "");
      if (this.update) {
        const { defaultTag, uid } = this.addressInfo;
        const params = {
          uid: uid,
          defaultTag: defaultTag,
          receiverName: this.name,
          receiverPhone: this.phone,
          detailAddress: area + this.info,
          province,
          city,
          county
        }
        getAddAddress(params, 'put').then(res => {
          if (res.result) {
            this.getSee();
            message({
              message: '修改地址成功',
              type: 'success'
            })
            $('#addrBox').fadeOut();
            this.clearForm()
          } else {
            message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        })
      } else { // 新增
        getAddAddress({
          receiverName: this.name,
          receiverPhone: this.phone,
          detailAddress: area + this.info,
          province,
          city,
          county,
          defaultTag: 1
        }, 'post').then(res => {
          if (res.result) {
            this.getSee();
            message({
              message: '添加地址成功',
              type: 'success'
            })
            $('#addrBox').fadeOut();
            this.clearForm();
          } else {
            message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        })
      }
    },
    // 删除地址
    delAddress (id, index) {
      this.$confirm('删除后不可恢复，确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        getAddAddress({
          uid: id,
        }, 'delete').then(res => {
          if (res.result) {
            this.getSee();
            this.listData.slice(index, 1)
            message({
              message: '删除地址成功',
              type: 'success'
            })
          }
        })
      }).catch(() => { });
    },
    // 默认地址
    setNormalAddress (id) {
      getAddAddress({
        uid: id,
        defaultTag: 1
      }, 'put').then(res => {
        if (res.result) {
          if (this.choose) {
            this.$router.go(-1)
          } else {
            this.getSee();
            message({
              message: '默认地址设置成功',
              type: 'success'
            });
          }
        }
      })
    },
    // 打开修改界面
    async showUpdateAddress (row, index) {
      this.update = true;
      this.addressInfo = row;
      this.name = row.receiverName;
      this.phone = row.receiverPhone;
      this.info = row.detailAddress;
      const { province, city, county } = row;
      this.addtions.selectedOptions = [province, city, county].map(str => parseInt(str, 10));
      $('#addrBox').fadeIn();
      // await getSeeAddress({
      // 	id: id,
      // 	jf: 'areae,parent'
      // }).then(res => {
      // 	if (res.result) {
      // 		// const addr = res.data.obj
      // 		const addr = res.data.pList[index]
      // 		this.addressId = addr.id
      // 		this.name = addr.name
      // 		this.phone = addr.phone
      // 		this.info = addr.info
      // 		const areae = addr.areae
      // 		this.addtions.selectedOptions = [areae.parent.parent.id, areae.parent
      // 			.id, areae
      // 			.id
      // 		]
      // 		let name = ''
      // 		this.addtions.selectedOptions.map(item => name += this.getAreaName(this.cities, item) +
      // 			',')
      // 		this.addtions.names = name;
      // 	}
      // })

    },
    clearForm () {
      this.addressInfo = {};
      this.name = '';
      this.phone = '';
      this.info = '';
      this.addtions = {
        selectedOptions: [],
        names: ''
      };
    }
  }
}
</script>

<style scoped>
/deep/ .el-cascader {
  width: 85%;
  height: 3.125rem;
}

/deep/ input::-webkit-input-placeholder {
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/receivingAddress.vue